// npm consumption
module.exports = require('./dist/proxy-polyfill.min');
